import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../../helpers/i18n';
import { useActions } from '../../../../../hooks';
import { selectBandwidthEffective4kCodec, toggleBandwidthEffective4kCodecAction } from '../../../../settings';
import { useShouldShowBandwidthTumbler } from '../../hooks/use-should-show-bandwidth-tumbler';
import { SettingsTumbler } from './settings-tumbler';

export const BandwidthEffective4kCodecTumbler: FunctionComponent = () => {
    const { toggleBandwidthEffective4kCodec } = useActions({
        toggleBandwidthEffective4kCodec: toggleBandwidthEffective4kCodecAction,
    });

    const bandwidthEffective4kCodec = useSelector(selectBandwidthEffective4kCodec);

    const onChange = () => toggleBandwidthEffective4kCodec(!bandwidthEffective4kCodec);

    const isShouldShowBandwidthTumbler = useShouldShowBandwidthTumbler();

    if (!isShouldShowBandwidthTumbler) {
        return null;
    }

    return (
        <SettingsTumbler
            label={i18n('settings-v2', 'bandwidth-effective-4k-codec-label')}
            description={i18n('settings-v2', 'bandwidth-effective-4k-codec-badge')}
            checked={bandwidthEffective4kCodec}
            onChange={onChange}
            testId="bandwidth-effective-4k-codec-tumbler"
        />
    );
};
